// // // src/pages/ProfitLossReport/components/ProfitLossTable.js
// import React, {  } from "react";
// import { useSelector } from "react-redux";
// import { Row, Col, Table } from "antd";
// import dayjs from "dayjs";
// import { useNavigate } from "react-router-dom";

// const fmt = (num) =>
//   Number(num || 0).toLocaleString(undefined, {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

// const ProfitLossTable = ({ printMode = false }) => {
//   const {
//     balances = {},
//     loading = false,
//     filters = {},
//   } = useSelector((state) => state.profitLoss || {});
  
//   const authInfo = useSelector((s) => s.authInfoReducer) || {};
//   const isIndia = authInfo?.country?.toLowerCase() === "india";
//   const taxLabel = isIndia ? "GST" : "VAT";
//   const navigate = useNavigate();


// const navigateTo = (tab) => {
//   let path;

//   if (filters?.filterType === "Lifetime") {
//     path = `${tab}?filterType=Lifetime`;
//   } else {
//     const dateFrom = filters?.fromDate
//       ? dayjs(filters.fromDate).toISOString()
//       : "";
//     const dateTo = filters?.toDate
//       ? dayjs(filters.toDate).toISOString()
//       : "";

//     path = `${tab}?dateFrom=${encodeURIComponent(
//       dateFrom
//     )}&dateTo=${encodeURIComponent(dateTo)}`;
//   }

//   navigate(path);
// }; //


//   // map of route keys to the old routes
//   const routeMap = {
//     purchase: "/reports/purchase-record",
//     transferReceived: "/inventory/transfer-receive-record",
//     serviceExpense: "/reports/service-expense-ledger",
//     salesReturn: "/reports/sales-return-record",
//     directExpense: "/reports/direct-expense-balance",
//     productWiseProfit: "/reports/item-wise-profit",
//     productProfitAmount: "/reports/item-wise-profit",
//     purchaseReturn: "/reports/purchase-return-record",
//     sales: "/reports/sales-record",
//     transfer: "/inventory/transfer-record",
//     service: "/service/service-record",
//     directIncome: "/reports/direct-income-balance",
//     closingInventory: "/reports/item-stock-report", // (changed routes)
//     indirectExpenses: "/reports/indirect-expenses-balance",
//     indirectIncome: "/reports/income-record",
//   };

//   // Build left (debit) rows
//   const debitRows = [
//     {
//       key: "purchase",
//       label: "Purchase Account",
//       value: balances.purchaseBalance,
//       routeKey: "purchase",
//     },
//     {
//       key: "transferReceived",
//       label: "Product Transfer Received Amount",
//       value: balances.productTransferReceivedBalance,
//       routeKey: "transferReceived",
//     },
//     {
//       key: "serviceExpense",
//       label: "Service Expense Account",
//       value: balances.serviceExpenseBalance,
//       routeKey: "serviceExpense",
//     },
//     {
//       key: "salesReturn",
//       label: "Sales Return",
//       value: balances.salesReturnBalance,
//       routeKey: "salesReturn",
//     },
//     {
//       key: "directExpense",
//       label: "Direct Expense",
//       value: balances.directExpenseBalance,
//       routeKey: "directExpense",
//     },
//     // Product Wise Profit row (click toggles details)
//     {
//       key: "productProfit",
//       label: "Product Wise Profit",
//       value: balances.itemProfitLoss,
//       routeKey: "productWiseProfit",
//       clickable: true,
//     },
//     {
//       key: "totalDebitAmount",
//       label: "Total Debit Amount:",
//       value: balances.debitAmount,
//       strong: true,
//     },
//     {
//       key: "productProfitAmount",
//       label: "Product Profit Amount",
//       value: `${authInfo.currency ?? ""} ${fmt(balances.itemProfitLoss)}`,
//       routeKey: "productProfitAmount",
//     },
//     {
//       key: "indirectExpense",
//       label: "Indirect Expense :",
//       value: balances.indirectExpenseBalance,
//     },
//     {
//       key: "netProfit",
//       label: "Net Profit/ Loss :",
//       value: `${authInfo.currency ?? ""} ${fmt(balances.netProfit)}`,
//       strong: true,
//     },
//     {
//       key: "totalDebit",
//       label: "Total Debit :",
//       value: balances.debitTotal,
//       strong: true,
//     },
//   ];

//   // Build right (credit) rows
//   const creditRows = [
//     {
//       key: "purchaseReturn",
//       label: "Purchase Return",
//       value: balances.purchaseReturnBalance,
//       routeKey: "purchaseReturn",
//     },
//     {
//       key: "sales",
//       label: "Sales Account",
//       value: balances.salesBalance,
//       routeKey: "sales",
//     },
//     {
//       key: "transfer",
//       label: "Product Transfer Amount",
//       value: balances.productTransferBalance,
//       routeKey: "transfer",
//     },
//     {
//       key: "service",
//       label: "Service Account",
//       value: balances.serviceBalance,
//       routeKey: "service",
//     },
//     {
//       key: "directIncome",
//       label: "Direct Income",
//       value: balances.directIncomeBalance,
//       routeKey: "directIncome",
//     },
//     {
//       key: "closingInventory",
//       label: "Closing Inventory",
//       value: balances.currentInventoryBalance,
//       routeKey: "closingInventory",
//     },
//     {
//       key: "totalCreditAmount",
//       label: "Total Credit Amount :",
//       value: balances.creditAmount,
//       strong: true,
//     },
//     {
//       key: "previousGrossProfit",
//       label: "Previous Gross Profit/Loss",
//       value: balances.netProfit,
//     },
//     {
//       key: "indirectIncome",
//       label: "Indirect Income :",
//       value: balances.indirectIncomeBalance,
//       routeKey: "indirectIncome",
//     },
//     {
//       key: "totalCredit",
//       label: "Total Credit :",
//       value: balances.creditTotal,
//       strong: true,
//     },
//   ];

//   // If product details are toggled on, insert a detail row after the productProfit row in left column
//   const leftData = [];
//   debitRows.forEach((r) => {
//     leftData.push(r);
//     if (r.key === "productProfit") {
//       // const detailText = `( Costing : ${fmt(
//       //   balances.itemCostingAmount
//       // )} , Sold : ${fmt(balances.itemSoldAmount)} , Reversal : ${fmt(
//       //   balances.item_profit_reversal
//       // )} , Replace Reversal : ${fmt(
//       //   balances.item_replace_loss
//       // )} , Replace Sold : ${fmt(balances.item_profit_replace)} ) = ${fmt(
//       //   balances.itemProfitLoss
//       // )}`;
//       // const detailText = `( Costing : ${fmt(
//       //   balances.itemCostingAmount
//       //   )} , Sold : ${fmt(balances.itemSoldAmount)} , Reversal : ${fmt(
//       //   balances.item_profit_reversal
//       //   )} ) = ${fmt(balances.itemProfitLoss)}`;

// const detailText = 
//   `Sold: ${fmt(balances.itemSoldAmount)}` +
//   ` - Costing: ${fmt(balances.itemCostingAmount)}` +
//   ` = ${fmt(balances.itemSoldAmount - balances.itemCostingAmount)}` +
//   ` | Reversal: -${fmt(balances.item_profit_reversal)}` +
//   ` | Direct Expense: -${fmt(balances.directExpenseBalance)}` +  // ✅ added
//   ` | Direct Income: +${fmt(balances.directIncomeBalance)}` +
//   ` | Service Expense: -${fmt(balances.serviceExpenseBalance)}` +
//   ` | Adjustment: +${fmt(balances.adjustmentBalance ?? 0)}` +
//   ` = ${fmt(balances.itemProfitLoss)}`;

//       leftData.push({
//         key: "productProfitDetail",
//         detail: true,
//         detailText,
//       });
//     }
//   });

//   const columns = [
//     {
//       title: "PARTICULARS",
//       dataIndex: "label",
//       key: "label",
//       render: (text, record) => {
//         // detail row: merge both columns and show text
//         if (record.detail) {
//           return {
//             children: (
//               <span style={{ fontStyle: "italic" }}>{record.detailText}</span>
//             ),
//             props: {
//               colSpan: 2,
//               style: { textAlign: "center", padding: "0.5rem" },
//             },
//           };
//         }

//         // clickable rows
//         if (record.clickable || record.routeKey) {
//           const route = routeMap[record.routeKey];
//           if (record.clickable) {
//             return (
//               <a
//                 style={{
//                   cursor: "pointer",
//                   fontWeight: record.strong ? 700 : 500,
//                 }}
//                 onClick={() => navigateTo(route)}
//               >
//                 {text}
//               </a>
//             );
//           } else if (route) {
//             return (
//               <a
//                 style={{
//                   cursor: "pointer",
//                   fontWeight: record.strong ? 700 : 500,
//                 }}
//                 onClick={() => navigateTo(route)}
//               >
//                 {text}
//               </a>
//             );
//           }
//         }

//         // normal
//         return (
//           <span style={{ fontWeight: record.strong ? 700 : 500 }}>{text}</span>
//         );
//       },
//     },
//     {
//       title: printMode ? "" : "Debit / Credit",
//       dataIndex: "value",
//       key: "value",
//       align: "right",
//       render: (val, record) => {
//         if (record.detail) {
//           return { children: null, props: { colSpan: 0 } };
//         }
//         if (record.strong) {
//           return <strong>{typeof val === "number" ? fmt(val) : val}</strong>;
//         }
//         return typeof val === "number" ? fmt(val) : val ?? "";
//       },
//     },
//   ];

//   return (
//     <Row gutter={16}>
//       <Col xs={24} md={12}>
//         <Table
//           rowKey="key"
//           columns={columns}
//           dataSource={leftData}
//           loading={loading}
//           pagination={false}
//           bordered
//           size={printMode ? "small" : "middle"}
//         />
//       </Col>

//       <Col xs={24} md={12}>
//         <Table
//           rowKey="key"
//           columns={columns}
//           dataSource={creditRows}
//           loading={loading}
//           pagination={false}
//           bordered
//           size={printMode ? "small" : "middle"}
//         />
//       </Col>
//     </Row>
//   );
// };

// export default ProfitLossTable;
import React from "react";
import { useSelector } from "react-redux";
import { Table, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useProfitLossData } from "./useProfitLossData";
import '../components/../../../../components/common/financial-print.css'

const fmt = (num) =>
  Number(num || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const ProfitLossTable = ({ printMode = false }) => {
  const {
    balances = {},
    loading = false,
    filters = {},
  } = useSelector((state) => state.profitLoss || {});

  const authInfo = useSelector((s) => s.authInfoReducer) || {};
  // const currency = authInfo?.currency ?? "";
  const navigate = useNavigate();

  const routeMap = {
    salesReturn: "/reports/sales-return-record",
    serviceExpense: "/reports/service-expense-ledger",
    sales: "/reports/sales-record",
    service: "/service?tab=record",
    serviceReturn: "/service-return?tab=record",
    directIncome: "/reports/direct-income-balance",
    directExpense: "/reports/direct-expense-balance",
    productWiseProfit: "/reports/item-wise-profit",
    indirectExpenses: "/reports/indirect-expenses-balance",
    indirectIncome: "/reports/income-record",
  };

  const navigateTo = (tab) => {
    const sep = tab.includes("?") ? "&" : "?";
    let dateFrom;
    let dateTo;
    if (filters?.filterType === "Lifetime") {
      // Target reports only understand date ranges, so lifetime is sent
      // as a wide range covering all realistic transaction dates.
      dateFrom = dayjs("2000-01-01").startOf("day").toISOString();
      dateTo = dayjs().endOf("day").toISOString();
    } else {
      dateFrom = filters?.fromDate
        ? dayjs(filters.fromDate).toISOString()
        : "";
      dateTo = filters?.toDate ? dayjs(filters.toDate).toISOString() : "";
    }
    navigate(
      `${tab}${sep}dateFrom=${encodeURIComponent(
        dateFrom
      )}&dateTo=${encodeURIComponent(dateTo)}`
    );
  };

  const b = balances;

  // ── Totals (all from backend) ─────────────────────────────────
  // const totalOperatingIncome =
  //   parseFloat(b.salesBalance || 0) -
  //   parseFloat(b.salesReturnBalance || 0) +
  //   parseFloat(b.serviceBalance || 0) +
  //   parseFloat(b.directIncomeBalance || 0);
const totalOperatingIncome =
  parseFloat(b.salesBalance || 0) +
  parseFloat(b.serviceBalance || 0) +
  parseFloat(b.directIncomeBalance || 0);
  const totalCOGS =
    parseFloat(b.itemCostingAmount || 0) +
    parseFloat(b.serviceExpenseBalance || 0) +
    parseFloat(b.directExpenseBalance || 0);

  const grossProfit = parseFloat(b.itemProfitLoss || 0);   // from backend
  const totalIndirectExpense = parseFloat(b.indirectExpenseBalance || 0);
  const totalIndirectIncome = parseFloat(b.indirectIncomeBalance || 0);
  const netProfit = parseFloat(b.netProfit || 0);           // from backend
 const { rows, currency } = useProfitLossData();

  // ── Row builder helpers ───────────────────────────────────────
  const sectionHeader = (key, label) => ({
    key,
    type: "sectionHeader",
    label,
    value: "",
  });

  const subRow = (key, label, value, routeKey) => ({
    key,
    type: "subRow",
    label,
    value,
    routeKey,
  });

  const totalRow = (key, label, value) => ({
    key,
    type: "total",
    label,
    value,
  });

  const profitRow = (key, label, value) => ({
    key,
    type: "profit",
    label,
    value,
  });

  // ── Table rows (mirrors your reference screenshot) ────────────
//   const rows = [
//     // ── Operating Income ────────────────────────────────────────
//     sectionHeader("inc-header", "Operating Income"),
//     subRow("sales", "Sales", b.salesBalance, "sales"),
//     subRow("salesReturn", "Less: Sales Return", -(b.salesReturnBalance || 0), "salesReturn"),
//     subRow("service", "Service Income", b.serviceBalance, "service"),
//     subRow("directIncome", "Direct Income", b.directIncomeBalance, "directIncome"),
//     totalRow("total-inc", "Total for Operating Income", totalOperatingIncome),

//     // ── Cost of Goods Sold ───────────────────────────────────────
//     sectionHeader("cogs-header", "Cost of Goods Sold"),
//     subRow("cogs", "Cost of Goods Sold", b.itemCostingAmount, "productWiseProfit"),
//     subRow("serviceExpense", "Service Expenses", b.serviceExpenseBalance, "serviceExpense"),
//     subRow("directExpense", "Direct Expenses", b.directExpenseBalance, "directExpense"),
//     totalRow("total-cogs", "Total for Cost of Goods Sold", totalCOGS),

//     // ── Gross Profit ─────────────────────────────────────────────
//     profitRow("grossProfit", "Gross Profit", grossProfit),

// {
//   key: "grossProfitDetail",
//   type: "detail",
//   label: `Sold: ${currency} ${fmt(b.itemSoldAmount)} - Costing: ${currency} ${fmt(b.itemCostingAmount)} = ${currency} ${fmt(b.itemSoldAmount - b.itemCostingAmount)} | Reversal: -${currency} ${fmt(b.item_profit_reversal)} | Direct Expense: -${currency} ${fmt(b.directExpenseBalance)} = ${currency} ${fmt(b.itemProfitLoss)}`,
//   value: "",
// },
//     // ── Non Operating / Indirect Expense ─────────────────────────
//     sectionHeader("exp-header", "Non Operating Expense"),
//     subRow("indirectExpense", "Indirect Expenses", b.indirectExpenseBalance, "indirectExpenses"),
//     totalRow("total-exp", "Total for Non Operating Expense", totalIndirectExpense),

//     // ── Non Operating / Indirect Income ──────────────────────────
//     sectionHeader("otherinc-header", "Non Operating Income"),
//     subRow("indirectIncome", "Indirect Income", b.indirectIncomeBalance, "indirectIncome"),
//     totalRow("total-otherinc", "Total for Non Operating Income", totalIndirectIncome),

//     // ── Net Profit ───────────────────────────────────────────────
//     profitRow("netProfit", "Net Profit / Loss", netProfit),
//   ];

  // ── Columns ───────────────────────────────────────────────────
  const columns = [
    {
      dataIndex: "label",
      key: "label",
      render: (text, record) => {
        switch (record.type) {
          case "sectionHeader":
            return (
              <strong style={{ fontSize: 14, color: "#000" }}>
                {text}
              </strong>
            );
          case "detail":
            return (
              <span style={{
                paddingLeft: 24,
                fontStyle: "italic",
                fontSize: 12,
                color: "#888"
              }}>
                {record.label}
              </span>
            );
          case "total":
            return (
              <span style={{ paddingLeft: 24, fontStyle: "normal" }}>
                {text}
              </span>
            );
          case "profit":
            return (
              <strong style={{ fontSize: 14 }}>{text}</strong>
            );
          case "subRow":
            if (record.routeKey && routeMap[record.routeKey]) {
              return (
                <a
                  style={{ paddingLeft: 24, cursor: "pointer" }}
                  onClick={() => navigateTo(routeMap[record.routeKey])}
                >
                  {text}
                </a>
              );
              
            }
            
            return <span style={{ paddingLeft: 24 }}>{text}</span>;
          default:
            return text;
        }
      },
    },
    {
      dataIndex: "value",
      key: "value",
      align: "right",
      width: 180,
      render: (val, record) => {
        if (val === "" || val === undefined || val === null) return "";
        const num = parseFloat(val);

        if (record.type === "profit") {
          return (
            <strong style={{ color: num >= 0 ? "green" : "red" }}>
              {num < 0 ? `(${currency} ${fmt(Math.abs(num))})` : `${currency} ${fmt(num)}`}
            </strong>
          );
        }
        if (record.type === "total") {
          return (
            <strong>
              {num < 0
                ? `(${currency} ${fmt(Math.abs(num))})`
                : `${currency} ${fmt(num)}`}
            </strong>
          );
        }
        if (num < 0) {
          return (
            <span style={{ color: "red" }}>
              ({currency} {fmt(Math.abs(num))})
            </span>
          );
        }
        return `${currency} ${fmt(num)}`;
      },
    },
  ];
  
  if (printMode) {
  return (
    <table className="financial-print-table">
      <tbody>
        <tr className="financial-print-heading">
          <td>ACCOUNT</td>
          <td style={{ textAlign: "right" }}>TOTAL</td>
        </tr>

        {rows.map((row) => {
          if (row.type === "sectionHeader") {
            return (
              <tr key={row.key} className="financial-print-section">
                <td colSpan={2}>{row.label}</td>
              </tr>
            );
          }

          if (row.type === "profit") {
            return (
              <tr key={row.key} className="financial-print-grand">
                <td>{row.label}</td>
                <td style={{ textAlign: "right" }}>
                  {currency} {fmt(row.value)}
                </td>
              </tr>
            );
          }

          if (row.type === "total") {
            return (
              <tr key={row.key} className="financial-print-total">
                <td>{row.label}</td>
                <td style={{ textAlign: "right" }}>
                  {currency} {fmt(row.value)}
                </td>
              </tr>
            );
          }

          if (row.type === "detail") {
            return (
              <tr key={row.key} className="financial-print-detail">
                <td colSpan={2}>{row.label}</td>
              </tr>
            );
          }

          return (
            <tr key={row.key} className="financial-print-row">
              <td>{row.label}</td>
              <td style={{ textAlign: "right" }}>
                {currency} {fmt(row.value)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}


  return (
  
    <Table
      rowKey="key"
      dataSource={rows}
      loading={loading}
      pagination={false}
      bordered
      showHeader={true}
      size={printMode ? "small" : "middle"}
      columns={[
        {
          title: "ACCOUNT",
          dataIndex: "label",
          key: "label",
          render: columns[0].render,
        },
        {
          title: "TOTAL",
          dataIndex: "value",
          key: "value",
          align: "right",
          width: 180,
          render: columns[1].render,
        },
      ]}
    />
  );
};

export default ProfitLossTable;